/**
 * @description Hook utilizado para manipular os exames genéricos
 * @author Diego Sabino Amorim de Araújo
 * @file useExameGenericoService.js
 * @license Copyright (c) 2022 SIGEP DIGETI ITEP/RN
 */

import { useDispatch } from 'react-redux'
import actionTypes from 'utils/actionTypes'
import { useFetch } from './useFetch'

export const useExameGenericoService = () => {
  const fetch = useFetch()
  const dispatch = useDispatch()

  const setActiveStepExameGenerico = (step) => {
    dispatch({
      type: actionTypes.SET_ACTIVE_STEP_EXAME_GENERICO,
      activeStep: step,
    })
  }

  const listarExameGenericoGlobal = async (id, setProcessando) => {
    try {
      if (setProcessando) setProcessando(true)
      const response = await fetch.get(`/exameGenerico/${id}/detalhado`)
      dispatch({
        type: actionTypes.SET_EXAME_GENERICO,
        exameGenerico: response.data.exameGenerico,
      })
    } catch (err) {
      return
    } finally {
      if (setProcessando) setProcessando(false)
    }
  }

  const atualizarExameGenerico = async (id, dados, setProcessando) => {
    try {
      if (setProcessando) setProcessando(true)
      await fetch.put(`/exameGenerico/${id}`, dados)
    } catch (err) {
      return
    } finally {
      if (setProcessando) setProcessando(false)
    }
  }

  return { setActiveStepExameGenerico, listarExameGenericoGlobal, atualizarExameGenerico }
}
